
/*  =======================================================================
 *  FD Notify
 *  Heavily inspired by Notyf, created by Carlos Roso
 *  https://github.com/caroso1222/notyf
 *  =======================================================================
 */
(function () {
    this.Notify = function () {
        //List of notifications currently active
        this.notifications = [];

        var defaults = {
            delay: 5000,
            alertIcon: 'notify-alert-icon',
            confirmIcon: 'notify-confirm-icon',
            infoIcon: 'notify-info-icon'
        }

        if (arguments[0] && typeof arguments[0] == "object") {
            this.options = extendDefaults(defaults, arguments[0]);
        } else {
            this.options = defaults;
        }
        // Checks to see if a notify container already exists on the page.
        // If it doesn't, create one.
        if (document.getElementsByClassName('notify-container').length) {
            this.container = document.getElementsByClassName('notify-container')[0];
        } else {
            var docFrag = document.createDocumentFragment();
            var notifyContainer = document.createElement('div');
            notifyContainer.className = 'notify-container';
            docFrag.appendChild(notifyContainer);
            document.body.appendChild(docFrag);
            this.container = notifyContainer;
        }


        //Stores which transitionEnd event this browser supports
        this.animationEnd = animationEndSelect();
    }

    //---------- Public methods ---------------
    /**
    * Shows an alert card
    */

    this.Notify.prototype.alert = function (alertMessage, persist, id) {
        var isPersistent = persist || false;
        var idString = id || "";
        var card = buildNotificationCard.call(this, alertMessage, this.options.alertIcon, isPersistent, idString);
        card.className += ' alert';
        this.container.appendChild(card);
        this.notifications.push(card);
    }


    /**
    * Shows a confirm card
    */
    this.Notify.prototype.confirm = function (alertMessage, persist, id) {
        var isPersistent = persist || false;
        var idString = id || "";
        var card = buildNotificationCard.call(this, alertMessage, this.options.confirmIcon, isPersistent, idString);
        card.className += ' confirm';
        this.container.appendChild(card);
        this.notifications.push(card);
    }


    /**
    * Shows a info card
    */
    this.Notify.prototype.info = function (alertMessage, persist, id) {
        var isPersistent = persist || false;
        var idString = id || "";
        var card = buildNotificationCard.call(this, alertMessage, this.options.infoIcon, isPersistent, idString);
        card.className += ' info';
        this.container.appendChild(card);
        this.notifications.push(card);
    }


    //---------- Private methods ---------------

    /**
    * Populates the source object with the value from the same keys found in destination
    */
    function extendDefaults(source, destination) {
        for (property in destination) {
            //Avoid assigning inherited properties of destination, only assign to source the destination own properties
            if (destination.hasOwnProperty(property)) {
                source[property] = destination[property];
            }
        }
        return source;
    }


    /**
    * Creates a generic card with the param message. Returns a document fragment.
    */
    function buildNotificationCard(messageText, iconClass, persist, id) {
        //Card wrapper
        var notification = document.createElement('div');
        notification.className = 'notify';
        notification.id = id;

        var wrapper = document.createElement('div');
        wrapper.className = 'notify-wrapper';

        var iconContainer = document.createElement('div');
        iconContainer.className = 'notify-icon';

        var icon = document.createElement('i');
        icon.className = iconClass;

        var message = document.createElement('div');
        message.className = 'notify-message';
        message.innerHTML = messageText;

        //Build the card
        iconContainer.appendChild(icon);
        wrapper.appendChild(iconContainer);
        wrapper.appendChild(message);
        notification.appendChild(wrapper);

        var _this = this;

        var hideNotification = function () {
            notification.className += " disappear";
            notification.addEventListener(_this.animationEnd, function (event) {
                event.target == notification && (notification.parentNode !== _this.container || _this.container.removeChild(notification));
            });
            var index = _this.notifications.indexOf(notification);
            _this.notifications.splice(index, 1);
            $(notification).off('click');
        };

        if (!persist) {
            setTimeout(function () {
                hideNotification();
            }, _this.options.delay);
        }

        $(notification).one('click', function () {
            hideNotification();
        });

        notification.style.cursor = "pointer";

        return notification;
    }


    // Determine which animationend event is supported
    function animationEndSelect() {
        var t;
        var el = document.createElement('fake');
        var transitions = {
            'transition': 'animationend',
            'OTransition': 'oAnimationEnd',
            'MozTransition': 'animationend',
            'WebkitTransition': 'webkitAnimationEnd'
        }

        for (t in transitions) {
            if (el.style[t] !== undefined) {
                return transitions[t];
            }
        }
    }
})();